import React, { ReactText } from 'react';
import {
  toast as reactToastify,
  ToastOptions,
  ToastContent,
} from 'react-toastify';
import { Container, Text, SuccessIcon, ErrorIcon } from './styled';

export const toast = {
  ...reactToastify,
  success,
  error,
};

function success(message: ToastContent, options?: ToastOptions): ReactText {
  return reactToastify.success(<SuccessMessage message={message} />, {
    toastId: message as string,
    ...options,
  });
}

function error(message: ToastContent, options?: ToastOptions): ReactText {
  return reactToastify.error(<ErrorMessage message={message} />, {
    toastId: message as string,
    ...options,
  });
}

function SuccessMessage({ message }) {
  return (
    <Container>
      <SuccessIcon /> <Text>{message}</Text>
    </Container>
  );
}

function ErrorMessage({ message }) {
  return (
    <Container>
      <ErrorIcon /> <Text>{message}</Text>
    </Container>
  );
}

export default toast;
